import React from "react";
import { useRefinementList, UseRefinementListProps } from "react-instantsearch";
import { Label } from "@ui/components/label";
import { Checkbox } from "@ui/components/checkbox";

interface CustomRefinementListProps extends UseRefinementListProps {}

export const CustomRefinementList: React.FC<CustomRefinementListProps> = ({
  attribute,
}) => {
  const { items, refine } = useRefinementList({ attribute });

  return (
    <div className="flex flex-col gap-2 mt-4">
      <ul className="space-y-1">
        {items.map((item) => {
          if (item.label === "0") return;

          return (
            <li key={item.label} className="flex gap-2 items-center">
              <Checkbox
                id={`checkbox-${item.label}`}
                checked={item.isRefined}
                onCheckedChange={() => refine(item.value)}
              />
              <Label htmlFor={`checkbox-${item.label}`}>{item.label}</Label>
              <span className="text-md text-gray-500">({item.count})</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
